// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const perPageSize = 5;
export const SKIP_API_AFTER_LEAVE_WITHOUT_SAVING = true;
// export const API_BASE_URL = 'http://localhost:8000/';
// export const API_BASE_URL = 'http://3.6.142.67/backend/';  // dev branch
// export const API_BASE_URL = 'http://15.156.45.41/backend/'; // uat brach
export const API_BASE_URL = 'https://www.rwmportal.com/rtb/' //prod
export const GoogleReCaptchaKey = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

export const colorArray = ["#10291E", "#2B6251", '#2ba176', "#D1AD5F", '#DDBF77', "#8B8B8B", "#B1B1B1", '#222222', "#E3E2E2", "#D1D0D0", "#F4F4F4", "#a5a7a6", "#aaaaaa", "#c0c0c0", "#e6e6e6"];

export const paginationSizeOptions = [5, 10, 20, 50];

// SET THIS TYPE OF ARRAY FOR FUTURE USED
// const contributionTypes = {
//     1: 'Type 1',
//     2: 'Type 2',
//     // Add more types as needed
// };

export const rrCodeArray = [
   'F360', 'F361', 'F362', 'F363', 'F364', 'F365', 'F366', 'F367', 'F368', 'F369', 'F36A', 'F36B' ,'F36E'
];

export const titleArray = [
    { label: 'Mr', value: 1 },
    { label: 'Mrs.', value: 2 },
    { label: 'Ms.', value: 3 },
    { label: 'Miss', value: 4 },
    { label: 'Dr.', value: 5 },
    { label: 'M.', value: 6 },
    { label: 'Mme.', value: 7 },
    { label: 'Mlle.', value: 8 }
]
export const countryList = [
    { label: 'Canada', value: 1 },
    // { label: 'Usa', value: 2 }
];

export const relationshipList = [
    { label: 'Self', value: 1 },
    { label: 'Spouse Or Common Law', value: 2 },
    { label: 'Child', value: 3 },
    { label: 'Parent', value: 4 },
    { label: 'Sibling', value: 5 },
    { label: 'ParentInLaw', value: 6 },
    { label: 'Other', value: 7 },
];

export const mailRentOwnArray = [
    { label: 'Rent', value: 1 },
    { label: 'Own', value: 2 }
]

export const languageArray = [
    { label: 'English', value: 1 },
    { label: 'French', value: 2 }
]
export const currencyArray = [
    { label: 'CAD', value: 1 },
    { label: 'USD', value: 2 }
]

export const employmentDataArray = [
    { label: 'Employed', value: 1 },
    { label: 'Self-Employed', value: 2 },
    { label: 'Retired', value: 3 },
    { label: 'Unemployed', value: 4 },
    // { label: 'Student', value: 4 },
    { label: 'Homemaker', value: 5 },
]

export const relationArray = [
    { label: 'Father', value: 1 },
    { label: 'Mother', value: 2 },
    { label: 'Child', value: 3 },
    { label: 'Sibling', value: 5 },

    /* { label: 'Son', value: 3 },
    { label: 'Daughter', value: 4 }, 
    { label: 'Brother', value: 5 },
    { label: 'Sister', value: 6 },*/
    { label: 'Spouse', value: 7 },
    { label: 'Other', value: 8 },
    // { label: 'Uncle', value: 8 },
    // { label: 'Aunt', value: 9 },
    // { label: 'Cousin', value: 10 },
    // { label: 'Nephew', value: 11 },
    // { label: 'Niece', value: 12 },
    // { label: 'Grandson', value: 13 },
    // { label: 'Granddaughter', value: 14 }
];


export const registrationTypeArray = [
    { value: 1, label: 'Individual ' },
    { value: 2, label: 'Joint Account' },
    { value: 3, label: 'Individual ITF' },
    { value: 4, label: 'Joint Account ITF' }
]

export const externalInvestmentOptions = [
    { label: 'Equities', fields: ['eq_non_reg', 'eq_reg'] },
    { label: 'Fixed Income', fields: ['fi_non_reg', 'fi_reg'] },
    { label: 'Cash and Equivalents', fields: ['ce_non_reg', 'ce_reg'] },
    { label: 'Real Estate', fields: ['re_non_reg', 're_reg'] },
    { label: 'Commodities', fields: ['c_non_reg', 'c_reg'] }
];

export const spousalExternalInvestmentOptions = [
    { label: 'Equities', fields: ['s_eq_non_reg', 's_eq_reg'] },
    { label: 'Fixed Income', fields: ['s_fi_non_reg', 's_fi_reg'] },
    { label: 'Cash and Equivalents', fields: ['s_ce_non_reg', 's_ce_reg'] },
    { label: 'Real Estate', fields: ['s_re_non_reg', 's_re_reg'] },
    { label: 'Commodities', fields: ['s_c_non_reg', 's_c_reg'] }
];

export const radioOptionArray = [
    { label: 'Yes', value: 1 },
    { label: 'No', value: 2 }
];

export const contributionTypeArray = [
    { label: 'Cash', value: 1 },
    { label: 'Investment', value: 2 }
];

export const ownershipArray = [
    { label: 'Individual', value: 1 },
    { label: 'Joint', value: 2 },
    { label: 'Corp', value: 3 }
];
export const addressTypeArray = [
    { label: 'Civic', value: 1 },
    { label: 'Rural', value: 2 },
    { label: 'International', value: 3 }
];

export const roleOptions = [
    { value: 1, label: 'Account Holder ' },
    { value: 2, label: 'Beneficiary' },
    { value: 3, label: 'Director' },
    { value: 4, label: 'Officer' },
    { value: 5, label: 'Power of Attorney' },
    { value: 6, label: 'Secretary' },
    { value: 7, label: 'Settlor' },
    { value: 8, label: 'Third-party Operator' },
    { value: 9, label: 'Trading Authority' },
    { value: 10, label: 'Trustee' }
];

export const genderOption = [
    { label: 'Male', value: 1 },
    { label: 'Female', value: 2 }
];

export const maritalStatusArray = [
    { label: 'Single', value: 1 },
    { label: 'Married', value: 2 },
    { label: 'Common Law', value: 3 },
    { label: 'Separated', value: 4 },
    { label: 'Divorced', value: 5 },
    { label: 'Widowed', value: 6 },
    { label: 'Marié€', value: 7 },
    { label: 'Conjoint(e) de fait', value: 8 },
    { label: 'Divorcé(e)', value: 9 },
    { label: 'Séparé(e)', value: 10 },
    { label: 'Veuf ou veuve', value: 11 },
    { label: 'Jamais légalement marié(e) [célibataire]', value: 12 },
];

export const provinceList = [
    { label: 'Alberta', value: 1 },
    { label: 'British Columbia', value: 2 },
    { label: 'Manitoba', value: 3 },
    { label: 'New Brunswick', value: 4 },
    { label: 'Newfoundland and Labrador', value: 5 },
    { label: 'Nova Scotia', value: 6 },
    { label: 'Northwest Territories', value: 7 },
    { label: 'Nunavut', value: 8 },
    { label: 'Ontario', value: 9 },
    { label: 'Prince Edward Island', value: 10 },
    { label: 'Quebec', value: 11 },
    { label: 'Saskatchewan', value: 12 },
    { label: 'Yukon', value: 13 },
];

export const originOfContactList = [
    { label: 'Advertising', value: 1 },
    { label: 'Personal Contact', value: 2 },
    { label: 'Referral', value: 3 },
    { label: 'Telephone', value: 4 },
    { label: 'Office Visit', value: 5 },
    { label: 'Walk-In', value: 6 },
];

export const pacFrequencyList = [
    { label: 'Weekly', value: 1 },
    { label: 'Monthly', value: 2 },
    { label: 'Yearly', value: 3 }
];

export const accountOptionArray = [
    { label: 'Debit investment account', value: 1 },
    { label: 'Debit bank account', value: 2 }
];

export const roleTypeArray = [
    { label: 'Person', value: 1 },
    { label: 'Entity', value: 2 }
];

export const institutionTransferType = [
    { label: 'All in kind', value: 1 },
    { label: 'All in Cash', value: 2 },
    { label: 'Partial', value: 3 },
    { label: 'All Assets Mixed in Cash and in Kind', value: 4 }
];

export const AmlQiVerificationList = [
    { label: 'Identification Documents', value: 1 },
    { label: 'Credit Method (Form Completed)', value: 2 },
    { label: 'Dual Process Method', value: 3 },
    { label: 'Entity, Agent or Mandatory Identification Method', value: 4 }
];

export const profileInvestmentKnowledgeArray = [
    { label: 'Excellent', value: 1 },
    { label: 'Good', value: 2 },
    { label: 'Fair', value: 3 },
    { label: 'Novice', value: 4 }
];

export const profilePastExperienceArray = [
    { value: 1, isChecked: true, label: "None" },
    { value: 2, isChecked: false, label: "Stocks" },
    { value: 3, isChecked: false, label: "Bonds" },
    { value: 4, isChecked: false, label: "Mutual Funds" },
    { value: 5, isChecked: false, label: "GIC’s" },
    { value: 6, isChecked: false, label: "Mortgages" },
    { value: 7, isChecked: false, label: "Private Investments" },
    { value: 8, isChecked: false, label: "Other" },
];

export const suitabilityTextArray = [
    "I have received the Frontenac prospectus and understand the product",
    "Frontenac is a mortgage fund managed by CedarShore Asset Management Ltd.",
    "Frontenac is the only product offered by the Portfolio Manager",
    "º Pillar Financial Services Inc. administration fee of 1%",
    "My Capital is not guaranteed",
    "The return on Frontenac will fluctuate and past performance does not predict future performance",
    "Annual Share Redemption date is last business day of November",
    "Dividend options may be changed annually for January distribution",
    "I have a cash reserve for emergencies for the next year (One unforeseen circumstances will be considered for exemption - i.e. death, family breakdown, loss of employment, health/disability)"
];

export const suitabilityText = [
    { id: 1, isChecked: false },
    { id: 2, isChecked: false },
    { id: 3, isChecked: false },
    { id: 4, isChecked: false },
    { id: 5, isChecked: false },
    { id: 6, isChecked: false },
    { id: 7, isChecked: false },
    { id: 8, isChecked: false },
    { id: 9, isChecked: false }
]


export const healthArray = [
    { label: 'Excellent', value: 1 },
    { label: 'Good', value: 2 },
    { label: 'Fair', value: 3 },
    { label: 'Poor', value: 4 }
];

export const livingSituationArray = [
    { label: 'Living with Spouse', value: 1 },
    { label: 'Living Alone', value: 2 },
    { label: 'Living with Children', value: 3 },
    { label: 'Living in Assisted Care Facility', value: 4 }
];

export const authorizationTextArray = [
    "The information in this application and any additional pages attached is true and complete",
    "I agree to advise you immediately in writing of any material change in the information",
    "This account is not operated for the benefit of unnamed third party (Anti-Money Laundering)",
    "I (or a direct family member) am NOT an officer, director or owner of >10% voting rights of a Public issuer (Insider Status)",
    "Attach a void cheque to provide current banking information",
    "Consented to electronic delivery of documents provided by Portfolio Manager and have verified my email address Continue"
];

export const verificationTextArray = [
    "Was the client personally contacted?",
    "Is the client a Politically Exposed Foreign Person?",
    "Is the client an Industry (Investment) Professional?",
    "Is the client an Insider? **"
];

export const clientAccountTypesArray = [
    "Cash",
    "Margin",
    "TFSA",
    "RESP (Individual)",
    "RESP (Family)",
    "RIF (Individual)",
    "RIF (Spousal)",
    "RIF (Locked In)",
    "Cash Leveraged"
]
// not used
export const accountTypesArray = [
    { label: 'Cash', value: 1 },
    { label: 'Margin', value: 2 },
    { label: 'TFSA', value: 3 },
    { label: 'RESP (Individual)', value: 4 },
    { label: 'RESP (Family)', value: 5 },
    { label: 'RIF (Individual)', value: 6 },
    { label: 'RIF (Spousal)', value: 7 },
    { label: 'RIF (Locked In)', value: 8 },
    { label: 'Cash Leveraged', value: 9 },
    { label: 'RRSP', value: 10 },
    { label: 'RRSPSpousal', value: 11 },
    { label: 'RRSPGroup', value: 12 },
    { label: 'RRSPSpousalGroup', value: 13 },
    { label: 'RRSPLockedIn', value: 14 },
    { label: 'RLSP', value: 15 }
];


export const individualDocsArray = [
    "Passport",
    "Driver's License",
    "Citizen Card",
    "Other"
];

export const permissionForArray = [
    { label: 'Discretionary Account Opening', value: 1 },
    { label: 'EXEMPT NON - Discretionary Account Opening .', value: 2 },
    { label: 'Discretionary Account Opening   with ETFs', value: 3 },
    { label: 'CLIENT TRANSACTIONS', value: 4 },
    { label: 'KYC / OTHER.', value: 5 }
]

export const roleRegistrationTypeArray = [
    { label: 'Super Admin', value: 1 },
    { label: 'Approver', value: 2 },
    { label: 'In the field', value: 3 },
    { label: 'Back Office', value: 4 }
]

export const useOfAccountArray = [
    { value: 1, label: 'General income for current or future expense ' },
    { value: 2, label: 'Partially fund my retirement' },
    { value: 3, label: 'Fully fund my retirement' },
    { value: 4, label: 'Steady accumulation of wealth' },
    { value: 5, label: 'Market speculation' },
    { value: 6, label: 'Pay for education' },
    { value: 7, label: 'Preservation of wealth for succession purpose' },
    { value: 8, label: 'Other' }
];

export const initialInvestmentArray = [
    { value: 1, label: 'Cheque ' },
    { value: 2, label: 'Transfer' },
    { value: 3, label: 'Electronic Fund Transfer' },
    { value: 4, label: 'Loan/Line of Credit' }
];


export const employmentAddressOption = [
    { label: 'As Specified Below', value: 0 },
    { label: 'Same As Residential Address', value: 1 },
    { label: 'Same As Mailing Address', value: 2 }
];

export const holderMaterialsOptions = [
    { value: '1', label: 'All' },
    { value: '2', label: 'Decline' },
    { value: '3', label: 'Contact Issuer' }
];

export const accountFilterOptions = [
    { value: '1', label: 'All' },
    { value: '2', label: 'Active' },
    { value: '3', label: 'Inactive' }
];

export const agreementFilterOptions = [
    { value: '0', label: 'Does Not Send' },
    { value: '1', label: 'Sent(Not Signed)' },
    { value: '2', label: 'Signed' }
];

export const parentStepOptions = [
    { value: '0', label: 'Household' },
    { value: '1', label: 'Accounts' },
    // { value: '3', label: 'Client Group' }
    { value: '2', label: 'Risk Questionnaire' },
    { value: '3', label: 'Review' },
    { value: '4', label: 'Agreement' },
    { value: '5', label: 'Thank You' },
    { value: '6', label: 'Access To Dashboard' },
    // { value: '7', label: 'Thank You' },
];

export const assetCategoriesOptions = [
    { value: 1, label: 'Public Equity' },
    { value: 2, label: 'Public Fixed Income' },
    { value: 3, label: 'Private Credit' },
    { value: 4, label: 'Alternatives' },
    { value: 5, label: 'Enhanced Yield' }
];


export const fundTypeArray = [
    { value: 1, label: 'Equity fund' },
    { value: 2, label: 'Fixed income fund' },
    { value: 3, label: 'Enhanced yield fund' },
    { value: 4, label: 'Alternatives Fund' }
];

export const fundTypeOptions = [
    { value: 1, label: 'Private' },
    { value: 2, label: 'Public' },
]

export const securityInvestmentTypeArray = [
    { value: 1, label: 'Equities' },
    { value: 2, label: 'Mutual Funds' },
]

export const rolePermissionArray = [
    { value: 1, label: 'Head Office AR' },
    { value: 2, label: 'Head Office AAR' },
    { value: 4, label: 'Super Admin' },
    { value: 6, label: 'VP Compliance' },
    { value: 7, label: 'Admin' },
    { value: 8, label: 'Independent Portfolio Manager' },
    { value: 9, label: 'ADMIN- Independent Portfolio Manager' },
]

export const accountTypeDataArray = [
    { label: 'Electronic Fund Transfer', name: 'account_eft', defaultValue: 2 },
    { label: 'Transfers', name: 'account_transfer' },
    { label: 'Pre-Authorization Contribution', name: 'account_pac' },
    { label: 'Systematic Withdrawal Plan', name: 'account_swp' },
    { label: 'Income Sweep', name: 'account_income_sweep', defaultValue: 2, disabled: true }
];

export const questionnaireNotesArray = [
    'Primary Investment Goals',
    'Time Horizon',
    'Liquidity Needs',
    'Risk Capacity',
    'Risk Tolerance',
    'Unique Constraints',
    'Summary',
    'Unified Risk Profile',
];


export const radioColorSx = {
    color: '#124734',
    '&.Mui-checked': {
        color: '#124734',
    },
};
export const checkboxColorSx = {
    color: '#124734',
    '&.Mui-checked': {
        color: '#124734',
    },
};

// make this in common.jsx
export const calculateTotalYears = (birthDate) => {
    const today = new Date();

    const diffInMilliseconds = today - new Date(birthDate);
    const totalYears = diffInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);

    return totalYears;
};

export const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};


// get label for display data instead of number.


export const getLanguageLabel = (value) => {
    const language = languageArray.find(lang => lang.value == value);
    return language ? language.label : '-';
};
export const getAccountTypeLabel = (value) => {
    const language = accountTypesArray.find(lang => lang.value == value);
    return language ? language.label : '-';
};

export const getRole = (value) => {
    const dataValue = roleTypeArray.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};

export const getRegistrationTypeLabel = (value) => {
    const dataValue = registrationTypeArray.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};

export const getMaritalLabel = (value) => {
    const dataValue = maritalStatusArray.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};

export const getRoleLabels = (values) => {

    if (!values) return '';
    const numbersArray = values.split(',');
    return numbersArray.map(value => {
        const role = roleOptions.find(role => role.value == value);
        return role ? role.label : '';
    }).join(', ');
};

export const getCountryLabel = (value) => {
    const dataValue = countryList.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};

export const getProvinceLabel = (value) => {
    const dataValue = provinceList.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};

export const getGenderLabel = (value) => {
    const dataValue = genderOption.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};
export const getEmploymentLabel = (value) => {
    const dataValue = employmentDataArray.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};
export const getInstitutionTransferTypeLabel = (value) => {
    const dataValue = institutionTransferType.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};
export const getCurrencyLabel = (value) => {
    const dataValue = currencyArray.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};
export const getContributionTypeLabel = (value) => {
    const dataValue = contributionTypeArray.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};
export const getPacFrequencyLabel = (value) => {
    const dataValue = pacFrequencyList.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};
export const getAccountOptionLabel = (value) => {
    const dataValue = accountOptionArray.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};
export const getTitleLabel = (value) => {
    const dataValue = titleArray.find(lang => lang.value == value);
    return dataValue ? dataValue.label : '-';
};
export const getOriginOfContactLabel = (value) => {
    const dataValue = originOfContactList.find(data => data.value == value);
    return dataValue ? dataValue.label : '-';
};

export const getAddressTypeArrayLabel = (value) => {
    const dataValue = addressTypeArray.find(data => data.value == value);
    return dataValue ? dataValue.label : '-';
};

export const getYesNoLabel = (value) => {
    return value == 1 ? 'Yes' : 'No';
}

export const getHolderMaterials = (value) => {
    const dataValue = holderMaterialsOptions.find(data => data.value == value);
    return dataValue ? dataValue.label : '-';
}

export const getRelationsLabel = (value) => {
    const dataValue = relationshipList.find(data => data.value == value);
    return dataValue ? dataValue.label : '-';
}
export const getAmlQiVerificationLabel = (value) => {
    const dataValue = AmlQiVerificationList.find(data => data.value == value);
    return dataValue ? dataValue.label : '-';
}

export const defaultPersonalDetails = {
    "p_title": 0,
    "p_first_name": "",
    "p_middle_name": "",
    "p_last_name": "",
    "p_email": "",
    "p_dob": "",
    "p_sin": null,
    "p_marital_status": '',
    "p_no_of_dependent": null,
    "p_citizenship": "",
    "p_gender": 0,
    "p_home_phone": "",
    "p_cell_phone": "",
    "p_business_phone": "",
    "p_extension": "",
    "p_employment_status": '',
    "p_emp_job_title": "",
    "p_emp_name": "",
    "p_emp_business": "",
    "p_emp_years_employment": "",
    "p_emp_retirement_date": null,
    "s_first_name": null,
    "s_middle_name": null,
    "s_last_name": null,
    "s_email": null,
    "s_dob": null,
    "s_sin": null,
    "s_marital_status": 1,
    "s_no_of_dependent": null,
    "s_citizenship": '',
    "s_gender": null,
    "s_home_phone": null,
    "s_cell_phone": null,
    "s_business_phone": null,
    "s_extension": null,
    "s_employment_status": '',
    "s_emp_job_title": "",
    "s_emp_name": "",
    "s_emp_business": "",
    "s_emp_years_employment": "",
    "s_emp_retirement_date": null,
    "s_investing_account": null,
    "jt_title": null,
    "jt_marital_status": null,
    "jt_first_name": null,
    "jt_middle_name": null,
    "jt_last_name": null,
    "jt_sin": null,
    "jt_dob": null,
    "jt_email": null,
    "jt_home_phone": null,
    "jt_business_phone": null,
    "jt_extension": null,
    "jt_address_type": null,
    "jt_rr_no": null,
    "jt_street_name": null,
    "jt_street_no": null,
    "jt_street_type": null,
    "jt_unit_no": null,
    "jt_unit_type": null,
    "jt_city": null,
    "jt_province": null,
    "jt_country": null,
    "jt_postal_code": null,
    "jt_emp_name": null,
    "jt_emp_business": null,
    "jt_occupation": null,
    "jt_s_first_name": null,
    "jt_no_of_dependent": null,
    "jt_citizenship": null,
    "jt_s_middle_name": null,
    "jt_s_last_name": null,
    "jt_s_emp_name": null,
    "jt_s_emp_business": null,
    "jt_s_occupation": null
}

export const defaultAddressDetails = {
    "l_country": '',
    "l_unit_no": "",
    "l_unit_type": null,
    "l_street_no": null,
    "l_street_name": null,
    "l_street_type": null,
    "l_city": null,
    "l_province": '',
    "l_postal_code": null,
    "same_mailing_address": null,
    "m_country": null,
    "m_unit_no": null,
    "m_unit_type": null,
    "m_street_no": null,
    "m_street_name": null,
    "m_street_type": null,
    "m_city": null,
    "m_province": null,
    "m_postal_code": null,
    "third_party_address": null,
    "tp_country": 0,
    "tp_unit_no": "",
    "tp_unit_type": "",
    "tp_street_no": "",
    "tp_street_name": "",
    "tp_street_type": "",
    "tp_city": "",
    "tp_province": "",
    "tp_postal_code": ""
}

export const defaultFinancialDetails = {
    "enl_assets": null,
    "enf_assets": null,
    "annual_income": null,
    "total_net_worth": null,
    "eq_non_reg": null,
    "eq_reg": null,
    "fi_non_reg": null,
    "fi_reg": null,
    "ce_non_reg": null,
    "ce_reg": null,
    "re_non_reg": null,
    "re_reg": null,
    "c_non_reg": null,
    "c_reg": null,
    "s_enl_assets": null,
    "s_enf_assets": null,
    "s_annual_income": null,
    "s_total_net_worth": null,
    "s_eq_non_reg": null,
    "s_eq_reg": null,
    "s_fi_non_reg": null,
    "s_fi_reg": null,
    "s_ce_non_reg": null,
    "s_ce_reg": null,
    "s_re_non_reg": null,
    "s_re_reg": null,
    "s_c_non_reg": null,
    "s_c_reg": null
}

export const defaultRegulatoryDetails = {
    "client_account_operated_by_third_party": null,
    "client_electronic_delivery": null,
    "client_holder_material": null,
    "client_interest": null,
    "client_ownership": null,
    "client_third_party_financial_interest": null,
    "client_view_statement": null,
    "client_waive_trade_confirmations": null,
    "source_initial_investment": [],
    "regulatory_power_of_attorney": 2,
    "poa_first_name": "",
    "poa_last_name": "",
    "poa_middle_name": "",
    "poa_citizenship": "",
    "poa_gender": "",
    "poa_sin": "",
    "poa_relationship_to_you": "",
    "poa_street_no": "",
    "poa_street_name": "",
    "poa_unit_no": "",
    "poa_city": "",
    "poa_province": "",
    "poa_country": "",
    "poa_postal_code": "",
    "poa_home_phone_no": "",
    "poa_cell_phone_no": "",
    "poa_business_phone_no": "",
    "poa_email": "",
    "poa_employment_status": '',
    "poa_emp_name": "",
    "poa_emp_retirement_date": null,
    "poa_emp_address_option": "",
    "poa_emp_street_no": "",
    "poa_emp_street_name": "",
    "poa_emp_apartment_no": "",
    "poa_emp_city": "",
    "poa_emp_postal_code": "",
    "poa_emp_province": "",
    "poa_emp_country": "",
    "regulatory_insider": 2,
    "regulatory_shareholder_ten": 2,
    "regulatory_shareholder_twenty": 2,
    "regulatory_ciro_member": 2,
    "regulatory_trusted_contact": 2,
    "tcp_client_name": "",
    "tcp_client_email": "",
    "tcp_client_phone_no": "",
    "tcp_client_relationship_to_you": "",
    "tcp_joint_app_name": "",
    "tcp_joint_app_email": "",
    "tcp_joint_app_phone_no": "",
    "tcp_joint_app_relationship_to_you": "",
    "regulatory_foreign_pep": 2,
    "regulatory_associated_foreign_pep": 2,
    "regulatory_domestic_pep": 2,
    "regulatory_associated_domestic_pep": 2,
    "regulatory_hio": 2,
    "regulatory_associated_hio": 2,
    "aml_representative_register": null,
    "regulatory_contact_application": null,
    "known_applicant_years": null,
    "known_applicant_months": null,
    "aml_in_person_verification": null,
    "aml_method": 2,
    "id_image_name": null,
    "dl_number": null,
    "dl_issued_province": null,
    "is_tax_resident_canada": null,
    "is_tax_resident_usa": null,
    "is_tax_resident_other": null,
    "is_tax_benefit": null,
    "dl_dob": null,
    "dl_doi": null,
    "dl_doe": null,
    "dl_date_dov": null,
    "sin": null
}


export const fileContentTypes = {
    'pdf': 'application/pdf',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png'
};


export const downloadCSVFile = (rows, headers, filename, mapper) => {
    if (!rows?.length) return;

    //  escape CSV values safely
    const escapeCSV = (value) => {
        if (value === null || value === undefined) return "";

        const stringValue = String(value).replace(/"/g, '""');

        // wrap in quotes if contains comma/newline
        if (/[",\n]/.test(stringValue)) {
            return `"${stringValue}"`;
        }

        return stringValue;
    };

    const csvRows = [];

    // header row
    csvRows.push(headers.map(escapeCSV).join(","));

    // data rows
    rows.forEach((item) => {
        const mappedRow = mapper(item);
        csvRows.push(mappedRow.map(escapeCSV).join(","));
    });

    const blob = new Blob([csvRows.join("\n")], {
        type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();

    // cleanup
    setTimeout(() => window.URL.revokeObjectURL(url), 100);
};



export function CalendarIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none">
            <rect x="3" y="5" width="18" height="16" rx="3"></rect>
            <path d="M8 3v4M16 3v4M3 10h18"></path>
        </svg>
    );
}

export function DollarIcon() {
    return (
        <svg viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="24"></circle>
            <path
                d="M25.3 13.5v3.1c2.6.3 4.4 1.9 4.8 4.1h-3.2c-.3-.9-1-1.6-2.7-1.6-1.8 0-2.8.7-2.8 1.9 0 1.1.9 1.6 3.5 2.1 3.4.8 5.7 1.9 5.7 5.1 0 2.8-2.2 4.6-5.3 4.9v3h-2.5v-3.1c-3.1-.4-5.1-2.2-5.4-4.8h3.2c.3 1.3 1.5 2.2 3.3 2.2 1.8 0 3-.8 3-2.1 0-1.2-.9-1.8-3.7-2.5-3.1-.8-5.4-1.8-5.4-4.8 0-2.7 2.1-4.5 5.1-4.8v-3h2.4z"
                fill="currentColor"
            ></path>
        </svg>
    );
}

export function CheckIcon() {
    return (
        <svg viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="24"></circle>
            <path
                d="M16.5 24.3l5.2 5.3 10.2-11.1"
                stroke="currentColor"
                strokeWidth="3.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
        </svg>
    );
}

export function PersonIcon() {
    return (
        <svg viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="24"></circle>
            <path
                d="M24 24a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm-9.5 10.5c1.8-4.3 5-6.5 9.5-6.5s7.7 2.2 9.5 6.5"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
        </svg>
    );
}

export function MemberIcon() {
    return (
        <span className="member-icon" style={{ background: "#b0b4cc" }}>
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 12a4.2 4.2 0 1 0 0-8.4 4.2 4.2 0 0 0 0 8.4zm0 2.1c-4 0-7.2 2.1-7.9 5.2-.1.4.2.7.6.7h14.6c.4 0 .7-.3.6-.7-.7-3.1-3.9-5.2-7.9-5.2z"></path>
            </svg>
        </span>
    );
}

export function RoleAdvisorIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="8.2" r="3.2"></circle>
            <path d="M6.5 18.2c.9-2.8 3-4.3 5.5-4.3s4.6 1.5 5.5 4.3"></path>
        </svg>
    );
}

export function RoleManagerIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none">
            <circle cx="8" cy="9" r="2.5"></circle>
            <circle cx="16" cy="9" r="2.5"></circle>
            <path d="M3.8 17.8c.8-2.2 2.4-3.3 4.2-3.3 1.1 0 2 .3 2.8 1"></path>
            <path d="M13.2 15.5c.8-.7 1.7-1 2.8-1 1.8 0 3.4 1.1 4.2 3.3"></path>
        </svg>
    );
}

export const loginFieldSx = {
    '& .MuiInputLabel-root': {
        fontSize: '13px',
        color: '#667085',
        '&.Mui-focused': { color: '#1a6b47' },
    },

    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        fontSize: '14px',
        backgroundColor: '#fff',

        // 🔥 remove MUI default left padding (adornment case)
        '&.MuiInputBase-adornedStart': {
            paddingLeft: '0 !important',
        },

        '& fieldset': { borderColor: '#d0d5dd' },
        '&.Mui-focused fieldset': {
            borderColor: '#1a6b47',
            borderWidth: '1.5px',
        },
    },

    // 🔥 remove input padding
    '& .MuiOutlinedInput-input': {
        paddingLeft: '0 !important',
        backgroundColor: '#fff !important',
    },

    // 🔥 FIX AUTOFILL BACKGROUND (Chrome)
    '& input:-webkit-autofill': {
        WebkitBoxShadow: '0 0 0 1000px #fff inset !important',
        WebkitTextFillColor: '#000 !important',
        transition: 'background-color 9999s ease-in-out 0s',
    },
    '& input:-webkit-autofill:hover': {
        WebkitBoxShadow: '0 0 0 1000px #fff inset !important',
    },
    '& input:-webkit-autofill:focus': {
        WebkitBoxShadow: '0 0 0 1000px #fff inset !important',
    },

    '& .MuiFormHelperText-root': {
        fontSize: '11.5px',
        mt: '4px',
    },
};


export const loginIconWrapSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '45px',
    minHeight: '50px',
    background: '#e8f5ef',
    borderRight: '1px solid #d0d5dd',
    flexShrink: 0,
    mr: '6px',            // ⬅ reduced gap
};

export const safeSum = (arr, key) =>
    (arr ?? []).reduce(
        (total, item) => total + (Number(key ? item?.[key] : item) || 0),
        0
    );

export const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
};

export const VALIDATION_ERROR_MESSAGES = 'One of the required information is not added or invalid. Please make sure all required field(s) have been entered correctly.';


/* const DATE_RANGE_OPTIONS = [
    { value: "range_12m", label: "Last 12 Months" },
    { value: "range_6m", label: "Last 6 Months" },
    { value: "range_3m", label: "Last 3 Months" },
    { value: "range_custom", label: "Custom Range" },
];

const QUICK_PRESETS = [
    { label: "Last 7 days", days: 7 },
    { label: "Last 14 days", days: 14 },
    { label: "Last 30 days", days: 30 },
    { label: "Last 90 days", days: 90 },
];

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const DAY_NAMES = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]; */







